import * as THREE from 'three';

let cheap = false;

// Low graphics lights surfaces with Lambert (diffuse only) instead of Standard (PBR): far fewer instructions per pixel,
// which is what phone GPUs run out of. Chosen once at startup, so a changed graphics setting reaches lighting after a reload.
export function useCheapLighting(on: boolean): void {
  cheap = on;
}

export const cheapLighting = (): boolean => cheap;

export function litMaterial(params: THREE.MeshStandardMaterialParameters): THREE.MeshStandardMaterial | THREE.MeshLambertMaterial {
  if (!cheap) return new THREE.MeshStandardMaterial(params);
  const { roughness: _r, metalness: _m, ...diffuse } = params;
  return new THREE.MeshLambertMaterial(diffuse as THREE.MeshLambertMaterialParameters);
}
